(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b4a-black-friday-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('b4a-price-promise')) {
  customElements.define('b4a-price-promise', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const trigger = this.querySelector('button');
      const bubble = this.querySelector('.b4a-bf__promise-copy');
      if (!trigger || !bubble) return;
      const hover = window.matchMedia('(hover: hover) and (pointer: fine)');
      const setOpen = (open) => {
        clearTimeout(this.closeTimer);
        bubble.hidden = !open;
        trigger.setAttribute('aria-expanded', String(open));
        if (open) {
          const title = bubble.querySelector('p:first-child strong');
          if (title) {
            title.style.fontSize = '';
            if (matchMedia('(max-width:719px)').matches) {
              title.style.fontSize = '18px';
              const range = document.createRange();
              range.selectNodeContents(title);
              const width = range.getBoundingClientRect().width;
              if (width > 0) title.style.fontSize = `${Math.floor(Math.min(18, 18 * (title.clientWidth - 1) / width) * 100) / 100}px`;
            }
          }
        }
        if (open && (this.classList.contains('b4a-bf__badge-promise') || this.classList.contains('b4a-bf__inline-details') || innerWidth <= 719)) {
          const anchor = trigger.getBoundingClientRect();
          const rect = bubble.getBoundingClientRect();
          bubble.style.left = `${Math.max(12, Math.min(anchor.right - rect.width, innerWidth - rect.width - 12))}px`;
          const top = anchor.top - rect.height - 10 >= 12 ? anchor.top - rect.height - 10 : anchor.bottom + 10;
          bubble.style.top = `${Math.max(12, Math.min(top, innerHeight - rect.height - 12))}px`;
        }
      };
      window.addEventListener('resize', () => setOpen(false), options);
      this.addEventListener('pointerenter', (event) => {
        if (hover.matches && event.pointerType !== 'touch') setOpen(true);
      }, options);
      this.addEventListener('pointerleave', (event) => {
        if (hover.matches && event.pointerType !== 'touch') {
          this.closeTimer = setTimeout(() => {
            if (!this.contains(document.activeElement)) setOpen(false);
          }, 180);
        }
      }, options);
      trigger.addEventListener('click', () => setOpen(hover.matches || bubble.hidden), options);
      trigger.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          setOpen(true);
          bubble.querySelector('a')?.focus();
        }
      }, options);
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget) && !this.matches(':hover')) setOpen(false);
      }, options);
      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) setOpen(false);
      }, options);
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !bubble.hidden) {
          const returnFocus = this.contains(document.activeElement);
          setOpen(false);
          if (returnFocus) trigger.focus();
        }
      }, options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      clearTimeout(this.closeTimer);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b4a-google-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('b4a-google-reviews')) {
    customElements.define('b4a-google-reviews', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.track = this.querySelector('.b4a-reviews__track');
        this.cards = Array.from(this.querySelectorAll('.b4a-reviews__card'));
        if (!this.track || !this.cards.length) return;
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.position = this.querySelector('.b4a-reviews__position');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.update(), 120);
        }, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move(event.key === 'ArrowRight' ? 1 : -1);
          }
          if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: this.motion() });
          }
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.b4a-reviews__card');
          if (card) this.track.scrollBy({ left: card.getBoundingClientRect().left - this.track.getBoundingClientRect().left, behavior: 'auto' });
        }, options);
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.querySelector('.b4a-reviews__controls').hidden = false;
        this.position.hidden = false;
        this.update();
      this.loadReviews();
      }
      motion() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
      move(direction) {
        if (!this.cards.length) return;
      const step = this.cards[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).columnGap);
        this.track.scrollBy({ left: direction * step, behavior: this.motion() });
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.track.scrollLeft >= max - 2;
        const bounds = this.track.getBoundingClientRect();
        const visible = this.cards.map((card, index) => ({ rect: card.getBoundingClientRect(), index })).filter(({ rect }) => Math.min(rect.right, bounds.right) - Math.max(rect.left, bounds.left) > rect.width / 2);
        if (visible.length) this.position.textContent = this.dataset.positionLabel.replace('[first]', visible[0].index + 1).replace('[last]', visible[visible.length - 1].index + 1).replace('[total]', this.cards.length);
        this.cards.forEach(card => {
          const text = card.querySelector('.b4a-reviews__text');
          const link = card.querySelector('.b4a-reviews__read');
          if (link.tagName === 'BUTTON') {
          const expanded = link.getAttribute('aria-expanded') === 'true';
          link.hidden = !expanded && text.scrollHeight <= text.clientHeight + 1;
          link.textContent = expanded ? this.dataset.showLessLabel : this.dataset.readMoreLabel;
          return;
        }
        link.querySelector('[data-link-label]').textContent = text.scrollHeight > text.clientHeight + 1 || link.dataset.excerpt === 'true' ? this.dataset.readMoreLabel : this.dataset.viewLabel;
        });
      }
      async loadReviews() {
      const controller = this.controller;
      const fetchController = new AbortController();
      controller.signal.addEventListener('abort', () => fetchController.abort(), { once: true });
      const timeout = setTimeout(() => fetchController.abort(), 12000);
      try {
        const response = await fetch(this.dataset.endpoint, {
          signal: fetchController.signal,
          credentials: 'omit'
        });
        if (!response.ok) throw new Error('Reviews unavailable');
        const data = await response.json();
        if (!Array.isArray(data.reviews) || !data.reviews.length ||
            !Number.isInteger(data.totalReviewCount) || data.totalReviewCount < 1 ||
            typeof data.averageRating !== 'number' || data.averageRating < 1 || data.averageRating > 5) return;
        const reviews = data.reviews.slice(0, 10);
        if (!reviews.every(review => typeof review.author === 'string' &&
            typeof review.text === 'string' && Number.isInteger(review.rating) &&
            review.rating >= 1 && review.rating <= 5)) return;
        if (!this.isConnected || this.controller !== controller) return;
        const template = this.cards[0];
        const fragment = document.createDocumentFragment();
        reviews.forEach((review, index) => {
          const card = template.cloneNode(true);
          card.removeAttribute('data-shopify-editor-block');
          card.querySelector('article').setAttribute('aria-label', this.dataset.reviewLabel.replace('[name]', review.author));
          card.querySelector('h3').textContent = review.author;
          const parts = review.author.trim().split(/\s+/);
          card.querySelector('.b4a-reviews__avatar').textContent =
            ((parts[0]?.[0] || '') + (parts.length > 1 ? parts[parts.length - 1][0] : '')).toUpperCase();
          const stars = card.querySelector('.b4a-reviews__stars');
          stars.setAttribute('aria-label', this.dataset.ratingLabel.replace('[rating]', review.rating));
          stars.querySelector('span').textContent = '★'.repeat(review.rating) + '☆'.repeat(5 - review.rating);
          const text = card.querySelector('.b4a-reviews__text');
          text.textContent = review.text;
          text.classList.remove('is-expanded');
          text.id = this.id + '-live-text-' + index;
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'b4a-reviews__read';
          button.textContent = this.dataset.readMoreLabel;
          button.setAttribute('aria-expanded', 'false');
          button.setAttribute('aria-controls', text.id);
          button.addEventListener('click', () => {
            const expanded = button.getAttribute('aria-expanded') !== 'true';
            button.setAttribute('aria-expanded', String(expanded));
            text.classList.toggle('is-expanded', expanded);
            this.update();
          }, { signal: this.controller.signal });
          card.querySelector('.b4a-reviews__read').replaceWith(button);
          fragment.append(card);
        });
        this.track.replaceChildren(fragment);
        this.cards = Array.from(this.track.children);
        this.track.scrollLeft = 0;
        const summary = this.querySelector('.b4a-reviews__summary');
        const rating = data.averageRating.toFixed(1);
        summary.querySelector('strong').textContent = rating;
        summary.querySelector('.b4a-reviews__count').textContent = this.dataset.countLabel.replace('[count]', data.totalReviewCount);
        summary.setAttribute('aria-label', this.dataset.summaryLabel.replace('[rating]', rating).replace('[count]', data.totalReviewCount));
        const stars = summary.querySelector('.b4a-reviews__stars');
        stars.style.background = `linear-gradient(to right, #b87500 ${data.averageRating * 20}%, #d5d9e0 ${data.averageRating * 20}%)`;
        stars.style.backgroundClip = 'text';
        stars.style.webkitBackgroundClip = 'text';
        stars.style.color = 'transparent';
        this.update();
      } catch {
      } finally {
        clearTimeout(timeout);
      }
    }
    disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        clearTimeout(this.scrollTimer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-recently-viewed"]) return;
  try {
    
  (() => {
    const initialize = () => {
      document.querySelectorAll('.b4a-recently-viewed-standardized').forEach(section => {
        if (section.dataset.b4aAligned) return;
        section.dataset.b4aAligned = 'true';
        const container = section.querySelector('[data-recently-viewed-container]');
        if (!container) return;
        const rows = [
          ['price', '.productitem--info > .productitem__price', 54],
          ['vendor', '.productitem--vendor', 22],
          ['stock', '.product-stock-level-wrapper, .productitem__stock-level', 60],
          ['extras', '.b4a-recently-viewed-coupon, .b4a-recently-viewed-reviews', 44]
        ];
        const observed = new Set();
        let frame = 0;
        const align = () => {
          frame = 0;
          if (!section.isConnected) {
            resize.disconnect();
            mutations.disconnect();
            return;
          }
          container.querySelectorAll('.productitem--info').forEach(info => {
            if (!info.querySelector('.b4a-recently-viewed-coupon')) {
              const coupon = [...info.children].find(element => element.querySelector('img[src*="_percent_coupon.png"]'));
              const wrapper = document.createElement('div');
              wrapper.className = 'b4a-recently-viewed-coupon';
              info.append(wrapper);
              if (coupon) wrapper.append(coupon);
            }
            if (!info.querySelector('.b4a-recently-viewed-reviews')) {
              const reviews = info.querySelector('.product__rating');
              const wrapper = document.createElement('div');
              wrapper.className = 'b4a-recently-viewed-reviews';
              info.append(wrapper);
              if (reviews) wrapper.append(reviews);
            }
            const title = info.querySelector('.productitem--title a');
            if (title && !title.hasAttribute('title')) title.title = title.textContent.trim();
          });
          let changed = false;
          rows.forEach(([name, selector, minimum]) => {
            const elements = [...container.querySelectorAll(selector)];
            const height = Math.ceil(Math.max(minimum, ...elements.map(element => element.getBoundingClientRect().height)));
            const property = `--b4a-recent-${name}-row`;
            const value = `${height}px`;
            if (section.style.getPropertyValue(property) !== value) {
              section.style.setProperty(property, value);
              changed = true;
            }
          });
          const current = new Set(container.querySelectorAll(rows.map(row => row[1]).join(', ')));
          observed.forEach(element => {
            if (!current.has(element)) {
              resize.unobserve(element);
              observed.delete(element);
            }
          });
          current.forEach(element => {
            if (!observed.has(element)) {
              resize.observe(element);
              observed.add(element);
            }
          });
          if (changed) requestAnimationFrame(() => window.dispatchEvent(new Event('resize')));
        };
        const schedule = () => {
          if (!frame) frame = requestAnimationFrame(align);
        };
        const resize = new ResizeObserver(schedule);
        const mutations = new MutationObserver(schedule);
        resize.observe(container);
        mutations.observe(container, { childList: true, subtree: true });
        schedule();
      });
    };
    initialize();
    document.addEventListener('shopify:section:load', initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-search"]) return;
  try {
    
  if (!customElements.get('b4a-search-sorting')) {
    customElements.define('b4a-search-sorting', class extends HTMLElement {
      connectedCallback() {
        requestAnimationFrame(() => {
          const select = this.querySelector('[data-b4a-search-sort]');
          const params = new URL(window.location.href).searchParams;
          if (select && params.get('options[unavailable_products]') === 'last' &&
              (!params.get('sort_by') || params.get('sort_by') === 'relevance')) {
            select.value = 'availability';
          }
        });
      }
    });
  }
  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-b4a-search-sort]')) return;
    const url = new URL(window.location.href);
    const availability = event.target.value === 'availability';
    url.searchParams.set('sort_by', availability ? 'relevance' : event.target.value);
    url.searchParams.set('options[unavailable_products]', availability ? 'last' : 'show');
    url.searchParams.delete('page');
    window.location.assign(url.toString());
  });

  } catch(e) { console.error(e); }
})();
})();
